import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import {
  CardDropEvent,
  CardOrganizerData,
  CardStack,
  Unit,
  UuidUtil,
  ElderCardOrganizerComponent,
  ElderStackCardDirective,
  ElderLocalizedInputComponent,
  ElderSelectComponent,
} from '@elderbyte/ngx-starter'
import { ProductionListPropertyDefinition } from '../production-list-property-definition'
import {
  ProductionListPropertyResolveSpec,
  ProductionListPropertyResolveType,
} from '../production-list-property-resolve-spec'
import { CellNumberFormat, ValueFormatSpec } from '../../columns/value-format-spec'
import { AttachmentSpec, AttachmentSpecType } from '../../../../attachments/spec/attachment-spec'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProductionListPropertyResolveSpecDetailComponent } from '../production-list-property-resolve-spec-detail/production-list-property-resolve-spec-detail.component'
import { MatFormField } from '@angular/material/form-field'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-item-property-definition-organizer',
  templateUrl: './production-list-property-definition-organizer.component.html',
  styleUrls: ['./production-list-property-definition-organizer.component.scss'],
  imports: [
    ElderCardOrganizerComponent,
    ElderStackCardDirective,
    ElderLocalizedInputComponent,
    FormsModule,
    MatFormField,
    ElderSelectComponent,
    ProductionListPropertyResolveSpecDetailComponent,
    ElderTranslatePipe,
  ],
})
export class ProductionListPropertyDefinitionOrganizerComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public cardData: CardOrganizerData<ProductionListPropertyDefinition>

  @Input()
  public embedded: boolean

  public unitList = (Object as any).values(Unit)

  public AttachmentSpecType = AttachmentSpecType

  @Output()
  public propertiesChange: EventEmitter<ProductionListPropertyDefinition[]> = new EventEmitter<
    ProductionListPropertyDefinition[]
  >()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.cardData = new CardOrganizerData<ProductionListPropertyDefinition>([
      CardStack.newStack('default', ''),
    ])
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set properties(props: ProductionListPropertyDefinition[]) {
    if (props) {
      this.cardData.replaceStackCards('default', props)
    }
  }

  public get properties(): ProductionListPropertyDefinition[] {
    return this.cardData.cards
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public onNewCard($event: CardStack<string, string>): void {
    this.cardData.addCard(
      'default',
      new ProductionListPropertyDefinition(
        UuidUtil.weakUuid4(),
        [],
        new ProductionListPropertyResolveSpec(
          ProductionListPropertyResolveType.RESOLVED_PROPERTY,
          null,
          null,
          null,
          new AttachmentSpec()
        ),
        new ValueFormatSpec(new CellNumberFormat(0), null)
      )
    )

    this.emitUpdates()
  }

  public onCardDrop($event: CardDropEvent<any>): void {
    this.emitUpdates()
  }

  public onRemoveCard($event: any): void {
    this.emitUpdates()
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private emitUpdates(): void {
    this.propertiesChange.emit(this.cardData.cards)
  }
}
